var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-favorites"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"great-title"},[_vm._t("title")],2),_c('div',{staticClass:"products"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }